{
  const BaseModule = require('_base/base');

  class EvenwidthImagesModule extends BaseModule {
    preInit() {
      this.isMother = true;
      this.availableHeight = 0;
    }

    postInit() {
      this.evenModules = [];
      this.$children = this.$el.children();
    }

    preCalculate() {
      this._findEvenSubModules(this);
      this._calculateRatios();
      this._calculateAvailableHeight();
    }

    postCalculate() {
      const widthConstraint = this._detectMinimalWidth();

      this.evenModules.forEach(subModule => {
        if (subModule.calculateWithConstraints) {
          subModule.calculateWithConstraints({
            width: widthConstraint,
            height: this.availableHeight * subModule.heightRatio,
          });
        }
      });
    }

    _findEvenSubModules(rootModule) {
      rootModule.subModules.forEach(subModule => {
        if (subModule.$el.is('.is__evenwidth, .is__evenWidth')) {
          this.evenModules.push(subModule)
        }

        this._findEvenSubModules(subModule)
      })
    }

    _detectMinimalWidth() {
      const widths = this.evenModules.map(module => module.calculatedWidth);

      return Math.min.apply(Math, widths);
    }

    _calculateRatios() {
      const totalRatio = this.evenModules.reduce((sum, module) => sum + (1 / module.ratio), 0);

      this.evenModules.forEach(module => {
        module.heightRatio = (1 / module.ratio) / totalRatio;
      });
    }

    _calculateAvailableHeight() {
      const boxHeight = this.$el.height();

      let contentHeight = this.$children
        .get()
        .reduce((sum, el) => sum + $(el).outerHeight(true), 0);

      contentHeight = this.evenModules
        .reduce((sum, module) => sum - module.$el.height(), contentHeight);

      this.availableHeight = boxHeight - contentHeight;
    }
  }

  $('.rows.is__evenwidths, .rows.is__evenWidths, .rows.is__evenwidth, .rows.is__evenWidth')
    .each(function() { new EvenwidthImagesModule($(this)) })
}
